/**************************************************
 * Nombre:       Lista_Productos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Tarjeta_Producto from "../../Tarjetas/Tarjeta_Producto";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";

const Lista_Productos = ({items=[]}) => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            spacing={sCell ? 2 : 4}
        >


            {items.map((item) => (
                <Grid container size={{xs: 6, sm: 3, md: 2.4}} sx={{justifyContent: 'flex-start'}}>
                    <Tarjeta_Producto item={item}/>
                </Grid>
            ))}


        </Grid>
    )

}
export default Lista_Productos

const productos = [1, 2, 3, 4, 5, 1, 2, 3, 4, 5]